import {IRecommendedOffer} from "../../../offer/types/IRecommendedOffer";
import {IRecommendedProperty} from "../../../property/types/IRecommendedProperty";
import {getThumbnailLink} from "../../../utils/get_thumbnail_link";
import {IApplicationMultiLeadData} from "../../types/multi_lead/IApplicationMultiLeadData";

export const transformRecommendedPropertyIntoMultiLeadData = (
    property: IRecommendedProperty,
    overrideData: Partial<IApplicationMultiLeadData> = {}
): IApplicationMultiLeadData => ({
    id: property.id,
    offerType: property.offer.type,
    offerName: property.offer.name,
    offerAddress: property.offer.address,
    offerVendorName: property.offer.vendor.name,
    offerVendorId: property.offer.vendor.id,
    offerPrivacyDataProcessorName: property.offer.configuration.personal_data_processor_name,
    offerPrivacyPolicyUrl: property.offer.configuration.privacy_policy_url,
    offerPersonalDataProcessorUrl: property.offer.configuration.personal_data_processor_url,
    offerVendorLogo: getThumbnailLink(property.offer.vendor.logo_url, 80, 60),
    offerDistanceFromTheAirport: property.offer.distance_from_the_airport,
    offerDistanceFromTheBeach: property.offer.distance_from_the_beach,
    coordinates: property.offer.geo_point.coordinates,
    price: property.price,
    priceVisibility: property.offer.vendor.configuration?.price_visibility,
    offerPriceVisibility: property.offer.configuration.price_visibility,
    vendorPriceVisibility: property.offer.vendor.configuration?.price_visibility,
    rooms: property.rooms,
    area: property.area,
    constructionDateRange: property.offer.construction_date_range,
    mainImage: {
        desktop: getThumbnailLink(property.offer.main_image_url, 224, 147),
        mobile: getThumbnailLink(property.offer.main_image_url, 155, 87)
    },
    distance: property.distance,
    region: {
        country: property.region.country
    },
    ...overrideData
});

export const transformRecommendedOfferIntoMultiLeadData = (
    offer: IRecommendedOffer,
    overrideData: Partial<IApplicationMultiLeadData> = {}
): IApplicationMultiLeadData => ({
    id: offer.id,
    offerType: offer.type,
    offerName: offer.name,
    offerAddress: offer.address,
    offerVendorName: offer.vendor.name,
    offerVendorId: offer.vendor.id,
    offerPrivacyDataProcessorName: offer.configuration.personal_data_processor_name,
    offerPrivacyPolicyUrl: offer.configuration.privacy_policy_url,
    offerPersonalDataProcessorUrl: offer.configuration.personal_data_processor_url,
    offerVendorLogo: getThumbnailLink(offer.vendor.logo_url, 80, 60),
    offerDistanceFromTheAirport: offer.distance_from_the_airport,
    offerDistanceFromTheBeach: offer.distance_from_the_beach,
    coordinates: offer.geo_point.coordinates,
    mainImage: {
        desktop: getThumbnailLink(offer.main_image_url, 277, 160),
        mobile: getThumbnailLink(offer.main_image_url, 155, 87)
    },
    distance: offer.distance,
    region: {
        country: offer.region.country
    },
    ...overrideData
});
import {IRecommendedOffer} from "../../../offer/types/IRecommendedOffer";
import {IRecommendedProperty} from "../../../property/types/IRecommendedProperty";
import {getThumbnailLink} from "../../../utils/get_thumbnail_link";
import {IApplicationMultiLeadData} from "../../types/multi_lead/IApplicationMultiLeadData";

export const transformRecommendedPropertyIntoMultiLeadData = (
    property: IRecommendedProperty,
    overrideData: Partial<IApplicationMultiLeadData> = {}
): IApplicationMultiLeadData => ({
    id: property.id,
    offerType: property.offer.type,
    offerName: property.offer.name,
    offerAddress: property.offer.address,
    offerVendorName: property.offer.vendor.name,
    offerVendorId: property.offer.vendor.id,
    offerPrivacyDataProcessorName: property.offer.configuration.personal_data_processor_name,
    offerPrivacyPolicyUrl: property.offer.configuration.privacy_policy_url,
    offerPersonalDataProcessorUrl: property.offer.configuration.personal_data_processor_url,
    offerVendorLogo: getThumbnailLink(property.offer.vendor.logo_url, 80, 60),
    offerDistanceFromTheAirport: property.offer.distance_from_the_airport,
    offerDistanceFromTheBeach: property.offer.distance_from_the_beach,
    coordinates: property.offer.geo_point.coordinates,
    price: property.price,
    priceVisibility: property.offer.vendor.configuration?.price_visibility,
    offerPriceVisibility: property.offer.configuration.price_visibility,
    vendorPriceVisibility: property.offer.vendor.configuration?.price_visibility,
    rooms: property.rooms,
    area: property.area,
    constructionDateRange: property.offer.construction_date_range,
    mainImage: {
        desktop: getThumbnailLink(property.offer.main_image_url, 224, 147),
        mobile: getThumbnailLink(property.offer.main_image_url, 155, 87)
    },
    distance: property.distance,
    region: {
        country: property.region.country
    },
    ...overrideData
});

export const transformRecommendedOfferIntoMultiLeadData = (
    offer: IRecommendedOffer,
    overrideData: Partial<IApplicationMultiLeadData> = {}
): IApplicationMultiLeadData => ({
    id: offer.id,
    offerType: offer.type,
    offerName: offer.name,
    offerAddress: offer.address,
    offerVendorName: offer.vendor.name,
    offerVendorId: offer.vendor.id,
    offerPrivacyDataProcessorName: offer.configuration.personal_data_processor_name,
    offerPrivacyPolicyUrl: offer.configuration.privacy_policy_url,
    offerPersonalDataProcessorUrl: offer.configuration.personal_data_processor_url,
    offerVendorLogo: getThumbnailLink(offer.vendor.logo_url, 80, 60),
    offerDistanceFromTheAirport: offer.distance_from_the_airport,
    offerDistanceFromTheBeach: offer.distance_from_the_beach,
    coordinates: offer.geo_point.coordinates,
    mainImage: {
        desktop: getThumbnailLink(offer.main_image_url, 277, 160),
        mobile: getThumbnailLink(offer.main_image_url, 155, 87)
    },
    distance: offer.distance,
    region: {
        country: offer.region.country
    },
    ...overrideData
});
